/** Ordered report-generation phases surfaced in the progress UI. */
export const REPORT_PROGRESS_PHASES = [
  { phase: 'starting', label: 'Starting', message: 'Starting report generation…' },
  { phase: 'loading', label: 'Loading', message: 'Loading conversation and files…' },
  { phase: 'pretext_extraction', label: 'Pretext extraction', message: 'Extracting pretexts and scripts…' },
  { phase: 'detail_extraction', label: 'Detail extraction', message: 'Building detailed fact inventory…' },
  { phase: 'llm_generation', label: 'LLM narrative', message: 'Generating comprehensive report…' },
  { phase: 'depth_reinforcement', label: 'Depth reinforcement', message: 'Reinforcing narrative depth…' },
  { phase: 'structure_validation', label: 'Structure validation', message: 'Validating report structure…' },
  { phase: 'translation_pass', label: 'Translation', message: 'Translating report…' },
  { phase: 'translation_client', label: 'Client translation', message: 'Translating to client language…' },
  { phase: 'finalizing', label: 'Finalizing', message: 'Saving report…' },
];

const PHASE_INDEX = Object.fromEntries(
  REPORT_PROGRESS_PHASES.map((item, index) => [item.phase, index]),
);

const PHASE_LABELS = Object.fromEntries(
  REPORT_PROGRESS_PHASES.map((item) => [item.phase, item.label]),
);

export const formatReportProgressStatus = (status) => {
  if (!status || status.status === 'idle') return null;

  const meta = REPORT_PROGRESS_PHASES.find((item) => item.phase === status.phase);
  const phaseLabel = PHASE_LABELS[status.phase]
    || (status.phase ? status.phase.replace(/_/g, ' ') : '');
  const message = (status.message || '').trim() || meta?.message || 'Report generation in progress';

  return {
    phase: status.phase || '',
    phaseLabel,
    message,
    label: message,
    detail: phaseLabel,
    progress: typeof status.progress === 'number' ? status.progress : null,
    warnings: Array.isArray(status.warnings) ? status.warnings : [],
  };
};

export const buildReportProgressSteps = (currentPhase) => {
  const currentIndex = PHASE_INDEX[currentPhase] ?? -1;
  const visiblePhases = REPORT_PROGRESS_PHASES.filter((item) => ![
    'translation_pass',
    'translation_client',
  ].includes(item.phase) || currentPhase === item.phase);

  return visiblePhases.map((item) => {
    const index = PHASE_INDEX[item.phase];
    let state = 'pending';
    if (currentIndex >= 0) {
      if (index < currentIndex) state = 'done';
      else if (index === currentIndex) state = 'active';
    }
    return {
      key: item.phase,
      label: item.label,
      message: item.message,
      state,
    };
  });
};
